import {checkSameTypeUnitRecruitmentLimit} from './checkSameTypeUnitRecruitmentLimit';
import {getPlayerUnits} from '../../players/getPlayerUnits';

/**
 * Превысит ли смена типа отряда лимит отрядов одного типа (не более 4, у
 * крысолюдов d6 и великанов d20 — свой лимит, см. getSameTypeUnitLimit).
 * Лимит держится не только при найме: улучшение может вести и в «младший» тип
 * (d10 -> d8), и отмена улучшения возвращает отряд к прежнему типу. Сам
 * меняющийся отряд в подсчет не входит — он уходит из своего типа.
 */
export const checkIfUnitTypeChangeExceedsLimit = (unitId, newUnitTypeId, player, units) => {
  const otherPlayerUnits = getPlayerUnits(player, units).filter((unit) => unit.id !== unitId);
  return !checkSameTypeUnitRecruitmentLimit(player, newUnitTypeId, otherPlayerUnits);
};
